<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="上架中" :value="1"></el-option>
          <el-option label="下架" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="addActivity">新增礼品</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #activity_time="{ row }">
        <div>
          <p>开始:{{ row.start_time }}</p>
          <p>结束:{{ row.end_time }}</p>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 2">下架</el-tag>
          <el-tag type="success" size="small" v-if="row.status === 1"
            >上架中</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="updateInfo(row)"
            >编辑</el-button
          >
            <el-button v-if="row.status == 2" type="success" size="small" @click="updateStatus(row,1)"
            >上架</el-button
          >
            <el-button v-if="row.status == 1"  type="warning" size="small" @click="updateStatus(row,2)"
            >下架</el-button
          >
          <el-button  type="danger" size="small" @click="del(row)"
            >删除</el-button
          >
        </div>
      </template>
    </auto-table>


        <editGift ref="edit" @success="getList(1)"></editGift>    
  </div>
</template>

<script>
import editGift from './components/editGift.vue';

export default {
    components:{
        editGift
    },
  data() {
    return {
      DataList: [],
      Option: [
         { name: "活动id", value: "activity_id" },
        { name: "名称", value: "gift_name" },
        { name: "价格", value: "amount" },
        { name: "状态", value: "status", type: "custom" },
        { name: "到期时间", value: "end_time"},
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    addActivity() {
      this.$refs.edit.open()
    },
    updateInfo(row) {
      this.$refs.edit.open(row)
    },
    del(row){
      this.$confirm("确定删除").then(()=>{
         this.$get('/user/userGift/delete',{id:row.id}).then(res=>{
          this.getList(1);
        })
      })
    },
    updateStatus(row,status){
        
        this.$post('/user/userGift/update',{id:row.id,status}).then(res=>{
          this.getList(1);
        })
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/userGift/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>